import {
  TOGGLE_EMAIL_STEP,
  UPDATE_LOGIN_EMAIL_ERROR,
  UPDATE_LOGIN_IS_FETCHING,
  UPDATE_LOGIN_OR_SIGN_UP,
  UPDATE_LOGIN_PASSWORD_ERROR,
  UPDATE_LOGIN_PLAIN_ERROR,
  UPDATE_NEW_OAUTH,
} from '../constants/actions';

export const updateLoginEmailError = err => {
  return { type: UPDATE_LOGIN_EMAIL_ERROR, err };
};

export const updateLoginIsFetching = isFetching => {
  return { type: UPDATE_LOGIN_IS_FETCHING, isFetching };
};

export const updateLoginPlainError = err => {
  return { type: UPDATE_LOGIN_PLAIN_ERROR, err };
};

export const updateNewOauth = newOauth => {
  return { type: UPDATE_NEW_OAUTH, newOauth };
};

export const updateLoginPasswordError = err => {
  return { type: UPDATE_LOGIN_PASSWORD_ERROR, err };
};

export const updateLoginOrSignUp = logIn => {
  return { type: UPDATE_LOGIN_OR_SIGN_UP, logIn };
};

export const toggleEmailStep = () => {
  return { type: TOGGLE_EMAIL_STEP };
};
